import {QueryParamsEnum} from 'presentation/constants';
import {useQueryParams} from 'presentation/pages/private/hooks';
import {useEffect, useState} from 'react';
import {UseMyHospitalizationFilterHeaderType} from './types';

export const useMyHospitalizationFilterHeader = ({
	listDrawerItens,
	titleListDrawer,
}: UseMyHospitalizationFilterHeaderType) => {
	const {SEARCH_PARAMS, setSearchParams} = useQueryParams();
	const {category: selectedCategory} = SEARCH_PARAMS;
	const IS_ALL = selectedCategory === 'all' || selectedCategory.length === 0;

	const [openDrawerState, setOpenDrawerState] = useState(false);
	const [selectedFilterState, setSelectedFilterState] = useState<string>(
		IS_ALL ? 'all' : selectedCategory,
	);

	const handleOpenDrawer = () => {
		setOpenDrawerState(true);
	};

	const handleCloseDrawer = () => {
		setOpenDrawerState(false);
	};

	const listFilters = listDrawerItens
		? [
				{
					categoryTitle: titleListDrawer ?? '',
					categoryItemsList: listDrawerItens?.map(currentFilter => ({
						active: selectedFilterState === currentFilter.category,
						title: currentFilter.label,
						onClick: () => setSelectedFilterState(currentFilter.category),
					})),
				},
			]
		: [];

	const handleClearSearchParams = () => {
		setSearchParams(prev => {
			prev.delete(QueryParamsEnum.CATEGORY);
			return prev;
		});
	};

	const handleSearchParams = (category: string) => {
		if (category === 'all') {
			handleClearSearchParams();
			return;
		}
		setSearchParams(prev => {
			prev.set(QueryParamsEnum.CATEGORY, category);
			return prev;
		});
	};

	const handleApplyFilter = () => {
		handleSearchParams(selectedFilterState);
		setOpenDrawerState(false);
	};

	const handleClearFilter = () => {
		handleClearSearchParams();
		setSelectedFilterState('all');
		setOpenDrawerState(false);
	};

	useEffect(() => {
		if (!selectedCategory) handleClearFilter();
	}, [selectedCategory]);

	return {
		openDrawerState,
		handleOpenDrawer,
		handleCloseDrawer,
		listFilters,
		handleApplyFilter,
		handleClearFilter,
		IS_ALL,
	};
};
